import type { ErrorComponentProps } from "@tanstack/react-router";

export function RoutePendingFallback() {
  return (
    <div className="flex h-full min-h-[60vh] w-full flex-col items-center justify-center gap-3">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-red-500/70 border-t-transparent" />
      <p className="text-sm uppercase tracking-[0.2em] text-slate-400">
        Loading
      </p>
    </div>
  );
}

export function RouteErrorComponent({ error }: ErrorComponentProps) {
  return (
    <div className="flex h-full min-h-[60vh] w-full flex-col items-center justify-center gap-4 text-center">
      <div className="rounded-md border border-red-600/60 bg-red-950/40 px-6 py-4 text-left shadow-lg shadow-red-900/60">
        <h2 className="text-lg font-semibold text-red-200">Error</h2>
        <p className="mt-2 text-sm text-red-100/80">
          Something went wrong while loading this view. Please refresh or try
          again shortly.
        </p>
        <pre className="mt-3 max-w-lg overflow-auto text-xs text-red-300/80">
          {error instanceof Error ? error.message : String(error)}
        </pre>
      </div>
    </div>
  );
}
